import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import { UIProvider } from "./context/UIContext";

import LandingScreen from "./screens/LandingScreen";
import LoginScreen from "./screens/LoginScreen";
import SignScreen from "./screens/SignScreen";
import ErrorScreen from "./screens/ErrorScreen";

import './static/css/global.css'
import SignEnterprice from "./screens/SignEnterprice";

const router = createBrowserRouter([
    {
        path: '/',
        element: <LandingScreen/>,
        errorElement: <ErrorScreen/>
    },
    {
        path: '/login',
        element: <LoginScreen/>,
        errorElement: <ErrorScreen/>
    },
    {
        path: '/sign',
        element: <SignScreen/>,
        errorElement: <ErrorScreen/>
    },
    {
        path: '/sign-enterprise',
        element: <SignEnterprice/>,
        errorElement: <ErrorScreen/>
    }
]);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
    <UIProvider>
        <RouterProvider router={router} />
    </UIProvider>
);